<template>
    <div>
        <!-- account_block -->
        <div class="row account_block mt_sm">
            <div class="col-12">
                <div class="info_title account_block_title">
                    <b>Данные аккаунта</b>. При необходимости измените свой
                    пароль и другие данные.
                </div>
                <div class="info_body">
                    <div class="form-inline ap_options">
                        <button
                            type="button"
                            class="btn btn_lg btn_common"
                            data-toggle="modal"
                            data-target="#modalAccount"
                        >
                            Показать данные аккаунта
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- //account_block -->

        <!-- Modal -->
        <div
            class="modal modal_account"
            id="modalAccount"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-xl modal-dialog-centered"
                role="document"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title title">Данные аккаунта</h5>
                        <button
                            type="button"
                            class="btn btn_lg btn_common btn_icononly"
                            data-dismiss="modal"
                            id="modalAccountClose"
                            ref="modalAccountClose"
                        >
                            <i class="f7-icons icon_lg">xmark</i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- form_block -->
                        <div class="row form_block mt_sm">
                            <div class="col-12">
                                <form action="">
                                    <div class="info_title">
                                        <b>Данные пользователя</b>
                                    </div>
                                    <div class="info_body">
                                        <div class="form-group">
                                            <label for="inputName">ФИО</label>
                                            <input
                                                type="text"
                                                name="name"
                                                class="form-control"
                                                id="inputName"
                                                v-model="userForm.name"
                                                @change.o="resetUserErrors"
                                                :class="{ 'is-invalid': userErrors.name }"
                                            />
                                            <small v-if="userErrors.name" class="invalid-feedback">
                                                {{ userErrors.name }}
                                            </small>
                                        </div>
                                        <div class="form-group mt_sm">
                                            <label for="inputEmail">Электронная почта</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="inputEmail"
                                                v-model="userForm.email"
                                                @change.o="resetUserErrors"
                                                :class="{ 'is-invalid': userErrors.email }"
                                            />
                                            <small id="" class="text-muted">
                                                При необходимости сменить адрес
                                                электронной почты обратитесь в
                                                поддержку сайта
                                            </small>
                                        </div>
                                        <div class="form-group mt_sm">
                                            <label for="inputPhone">Контактный телефон</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="inputPhone"
                                                v-model="userForm.phone"
                                                @change.o="resetUserErrors"
                                                :class="{ 'is-invalid': userErrors.phone }"
                                            />
                                            <small v-if="userErrors.phone" class="invalid-feedback">
                                                {{ userErrors.phone }}
                                            </small>
                                        </div>
                                        <div class="form-group mt_sm">
                                            <label for="inputPassword">Текущий пароль</label>
                                            <input
                                                type="password"
                                                class="form-control"
                                                id="inputPassword"
                                                v-model="userForm.password"
                                                @change.o="resetUserErrors"
                                                :class="{ 'is-invalid': userErrors.password }"
                                                autocomplete="off"
                                            />
                                            <small v-if="userErrors.password" class="invalid-feedback">
                                                {{ userErrors.password }}
                                            </small>
                                        </div>

                                        <div v-if="userOk" class="alert alert-success" role="alert">
                                            Сохранено!
                                        </div>

                                        <button
                                            type="button"
                                            class="btn btn_lg btn_common mt_xxs"
                                            @click.prevent="userSubmit"
                                        >
                                            Сохранить
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <!-- //form_block -->

                        <!-- form_block -->
                        <div class="row form_block mt_sm">
                            <div class="col-12">
                                <form action="">
                                    <div class="info_title">
                                        <b>Изменение пароля</b>
                                    </div>
                                    <div class="info_body">
                                        <div class="form-group">
                                            <label for="inputpassword">Новый пароль</label>
                                            <input
                                                type="password"
                                                class="form-control"
                                                id="inputpassword"
                                                v-model="passwordForm.password"
                                                @change.o="resetPasswordErrors"
                                                :class="{ 'is-invalid': passwordErrors.password }"
                                                autocomplete="off"
                                            />
                                            <small v-if="passwordErrors.password" class="invalid-feedback">
                                                {{ passwordErrors.password }}
                                            </small>
                                        </div>
                                        <div class="form-group mt_sm">
                                            <label for="inputpassword_confirmation">Новый пароль повторно</label>
                                            <input
                                                type="password"
                                                class="form-control"
                                                id="inputpassword_confirmation"
                                                v-model="passwordForm.password_confirmation"
                                                @change.o="resetPasswordErrors"
                                                :class="{ 'is-invalid': passwordErrors.password_confirmation }"
                                                autocomplete="off"
                                            />
                                            <small v-if="passwordErrors.password_confirmation" class="invalid-feedback">
                                                {{ passwordErrors.password_confirmation }}
                                            </small>
                                        </div>
                                        <div class="form-group mt_sm">
                                            <label for="inputCurrentPassword">Текущий пароль</label>
                                            <input
                                                type="password"
                                                class="form-control"
                                                id="inputCurrentPassword"
                                                v-model="passwordForm.currentPassword"
                                                @change.o="resetPasswordErrors"
                                                :class="{ 'is-invalid': passwordErrors.currentPassword }"
                                                autocomplete="off"
                                            />
                                            <small v-if="passwordErrors.currentPassword" class="invalid-feedback">
                                                {{ passwordErrors.currentPassword }}
                                            </small>
                                        </div>

                                        <div v-if="passwordOk" class="alert alert-success" role="alert">
                                            Сохранено!
                                        </div>

                                        <button
                                            type="button"
                                            class="btn btn_lg btn_common mt_xxs"
                                            @click.prevent="userSubmitPassword"
                                        >
                                            Сохранить
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <!-- //form_block -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['name', 'email', 'phone'],
    data:function () {
        return {
            userErrors: {},
            passwordErrors: {},
            userForm: {
                name: this.name,
                phone: this.phone,
                email: this.email,
                password: '',
            },
            passwordForm: {
                password: '',
                password_confirmation: '',
                currentPassword: '',
            },
            userOk: false,
            passwordOk: false,
        }
    },
    methods: {      
        userSubmit: function () {
            this.resetUserErrors();
            this.userOk = false;
            let error = false;

            if (!this.userForm.name.length) {
                this.userErrors.name = 'Обязательное поле';
                error = true;
            }

            if (!this.userForm.phone.length) {
                this.userErrors.phone = 'Обязательное поле';
                error = true;
            }

            if (!this.userForm.email.length) {
                this.userErrors.email = 'Обязательное поле';
                error = true;
            }

            if (this.userForm.password.length < 6) {
                this.userErrors.password = 'Пароль должен быть не короче 6 символов';
                error = true;
            }

            if (error) return;

            let params = {
                name: this.userForm.name,
                phone: this.userForm.phone,
                email: this.userForm.email,
                password: this.userForm.password,
            };

            axios.put("/ajax/profile/update", params).then((request) => {
                if (
                    typeof request.data.success != "undefined" &&
                    request.data.success
                ) {
                    this.userOk = true;         
                    this.$store.dispatch('checkAuth');

                    setTimeout(() => {
                        this.userOk = false;
                    }, 5000);
                }

                if (
                    typeof request.data.errors != "undefined" &&
                    request.data.errors
                ) {
                    this.userErrors = request.data.errors;
                }
            }).catch((error) => {
                if (
                    typeof error.response.data.errors != "undefined" &&
                    error.response.data.errors
                ) {
                    this.userErrors = error.response.data.errors;
                }
            });
        },
        userSubmitPassword: function () {
            this.resetPasswordErrors();

            this.passwordOk = false;

            let error = false;

            if (!this.passwordForm.currentPassword.length) {
                this.passwordErrors.currentPassword = 'Обязательное поле';
                error = true;
            }

            if (this.passwordForm.password.length < 6) {
                this.passwordErrors.password = 'Пароль должен быть не короче 6 символов';
                error = true;
            }

            if (this.passwordForm.password !== this.passwordForm.password_confirmation) {
                this.passwordErrors.password = 'Пароли не совпадают';
                this.passwordErrors.password_confirmation = 'Пароли не совпадают';
                error = true;
            }

            if (error) return;

            let params = {
                currentPassword: this.passwordForm.currentPassword,
                password: this.passwordForm.password,
                password_confirmation: this.passwordForm.password_confirmation,
            };

            axios.put("/ajax/profile/updatePassword", params).then((request) => {
                if (
                    typeof request.data.success != "undefined" &&
                    request.data.success
                ) {
                    this.passwordOk = true;

                    setTimeout(() => {
                        this.passwordOk = false;
                    }, 5000);
                }
            }).catch((error) => {
                if (
                    typeof error.response.data.errors != "undefined" &&
                    error.response.data.errors
                ) {
                    this.passwordErrors = error.response.data.errors;
                }
            });;
        },
        resetUserErrors: function (e) {
            this.userErrors = {};
        },      
        resetPasswordErrors: function (e) {
            this.passwordErrors = {};
        },
    },
    computed: {
    },
};
</script>
